import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  InjectionToken,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { ComponentDefinition, FormDocument, FormTemplate } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

export const WINDOW_TOKEN = new InjectionToken<Window>('Window location object');

interface SeparatorComponentDefinition extends ComponentDefinition {
  caption?: string;
  colour?: any;
  lineStyle?: any;
  size?: any;
}

@Component({
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{provide: WINDOW_TOKEN, useValue: window}]
})
export class SeparatorComponent extends AbstractComponent<SeparatorComponentDefinition> implements OnInit {
  @Input() document: FormDocument;
  @Input() fieldValue: any;
  @Input() template: FormTemplate;
  @Input() fieldName: string;
  @Input() formParameters: any;
  @Input() key: number;
  @Input() message: string;
  @Input() componentDefinition: SeparatorComponentDefinition;

  @Input() floatLabel: any;
  @Input() docs: object = {};
  elementName: string;
  colour: any;
  dotted: any;
  size: any;
  disabled: boolean;
  borderTopStyle: any;

  constructor(
    @Inject(WINDOW_TOKEN) private $window: Window,
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);

    this.colour = 'black';
    this.dotted = 'solid';
    this.size = '1px';
    this.borderTopStyle = this.size + ' ' + this.dotted + ' ' + this.colour;
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    if (this.componentDefinition.colour) {
      this.colour = this.componentDefinition.colour;
      const borderTopStyleArr = this.borderTopStyle.split(' ');
      borderTopStyleArr[borderTopStyleArr.map((x, i) => [i, x]).filter(x => x[1] === borderTopStyleArr[2])[0][0]] = this.colour;
      this.borderTopStyle = borderTopStyleArr.join(' ');
    }

    if (this.componentDefinition.lineStyle) {
      this.dotted = this.componentDefinition.lineStyle;
      const borderTopStyleArr = this.borderTopStyle.split(' ');
      borderTopStyleArr[borderTopStyleArr.map((x, i) => [i, x]).filter(x => x[1] === borderTopStyleArr[1])[0][0]] = this.dotted;
      this.borderTopStyle = borderTopStyleArr.join(' ');
    }

    if (this.componentDefinition.size) {
      this.size = this.componentDefinition.size;
      const borderTopStyleArr = this.borderTopStyle.split(' ');
      borderTopStyleArr[borderTopStyleArr.map((x, i) => [i, x]).filter(x => x[1] === borderTopStyleArr[0])[0][0]] = this.size;
      this.borderTopStyle = borderTopStyleArr.join(' ');
    }

  }

}

